const actions = [
  {
      title: 'Delay the habit.',
      text: 'Delay the decision to give in to the habit. Set a specific time, e.g. 5, 10, 30 or 60 minutes.',
  },
  {
      title: 'Distract yourself.',
      text: 'Distract yourself by doing something that will occupy your thoughts and grab your attention. Perhaps do something physical to use up the energy for cravings such as going for a walk or gardening, you could prepare a healthy meal, or you could draw a picture. Avoid passive activities that allow your thoughts to wander like watching TV. Make a note of the things you could do, and how long you will do them for.',
  },
  {
      title: 'Decide not to do the unhealthy behaviour.',
      text: 'After the set time, decide not to do the unhealthy behaviour that you want to stop. Remind yourself of all the advantages of not giving into the habit, the disadvantages of giving into the habit, the reasons you want to stop or change this habit, the goals you have that this habit will affect.',
  },
];

const tip = 'Use the 3 D\'s (delay, distract, decide) to distract yourself from unhealthy habits - practice this method every time you get the urge to do the behaviour you\'re trying to stop.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
